import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';

const BlockButton = ({togglePopup}) => (
    <button className="block-user-button" onClick={togglePopup}>
        {i18n.t('seller_card.block_user.open_text')}
    </button>
);

BlockButton.propTypes = {
    togglePopup: PropTypes.func
};

export default BlockButton;


// WEBPACK FOOTER //
// ./src/components/block_user/ModalWrapper/BlockButton/index.js